import BasePage from './BasePage';
import React from 'react';
import {
    Button,
    ButtonGroup,
    Card,
    CardBody,
    CardHeader,
    Col,
    Collapse,
    FormGroup,
    Label,
    Row,
    Table,
} from 'reactstrap';
import {changeParam2, changeParam3, isEmpty, isFailed, isSuccess, navigatePage, parseDate} from '../utils/Utilities';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import {IoMdSettings} from 'react-icons/io';
import SearchInput from '../components/SearchInput';
import Global, {DD_MM_YYYY_HH_MM_SS} from '../utils/Global';
import {ASSEMBLY_STATUS_COLOR} from 'enqc-utilities/src/utils/Global'
import Pagination from '../components/Pagination';
import queryString from 'query-string';
import SockJsClient from 'react-stomp';
import label from 'enqc-utilities/src/label/Label'

import {FiArrowDownCircle, FiArrowUpCircle} from "react-icons/all";
import DateInput from "../components/Widget/DateInput";
import ItemOption from "../components/Widget/ItemOption";
import {MdRestore} from "react-icons/md";
import Page from "../components/Page";
import ModelModal from "../components/modal/ModelModal";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import AssemblyDetailModal from "../components/modal/AssemblyDetailModal";
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import DropdownInput from "../components/form/DropdownInput";
import {delegateObjectsForSelection} from "enqc-utilities/src/utils/Utilities";
import UserButton from "../components/Widget/UserButton";
import StatusWidget from "../components/Widget/StatusWidget";
import CreateInspectionConfirmModal from "../components/modal/CreateInspectionConfirmModal";
import CreateInspectionSuccessModal from "../components/modal/CreateInspectionSuccessModal";
import InspectionFormCheckPage from "./InspectionFormCheckPage";


class AssemblyPage extends BasePage{

    constructor(props) {
        super(props);
        this.state ={
            ascending:false,
            sortir:'ay.updated',
            page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
            key:queryString.parse(this.props.query).tab?queryString.parse(this.props.query).tab:label.All,
            totalPage:0,
            totalElement:0,
            pageElement:0,
            startCreatedAt:null,
            endCreatedAt:null,
            startUpdatedAt:null,
            endUpdatedAt:null,
            assemblyStatuses:[],
            assemblies:[],
            models:[],
            model:{},
            modelModal:false,
            assemblyStatus:null,
            assemblyStatusId:null,
            selectedAssembly:{},
            assemblyDetailModal:false,
            createInspectionConfirmModal:false,
            createInspectionSuccessModal:false,
            inputSearch:queryString.parse(this.props.query).search?queryString.parse(this.props.query).search:"",
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchAllStatus()
        this.fetchModels()
    }

    componentWillReceiveProps(props, nextContext) {
        if (props != this.props) {
            let page = queryString.parse(props.query).page ? queryString.parse(props.query).page : 1
            let key = queryString.parse(props.query).tab ? queryString.parse(props.query).tab : label.All
            let inputSearch = queryString.parse(props.query).search ? queryString.parse(props.query).search : ""
            let assemblyStatuses = this.state.assemblyStatuses?this.state.assemblyStatuses:[]
            let assemblyStatusId = null
            if (key === label.All) {
                assemblyStatusId = null
            } else {
                assemblyStatuses.map((assemblyStatus)=>{
                    if (key == assemblyStatus.sortir) {
                        assemblyStatusId = assemblyStatus.id
                    }
                })
            }
            this.setState({
                page: page,
                key: key,
                inputSearch: inputSearch,
                assemblyStatusId: assemblyStatusId
            }, () => {
                this.fetchAll(this.state.ascending, this.state.sortir, this.state.inputSearch, true)
            })
        }
    }
    fetchAllStatus = () => {
        let {key} = this.state
        this.get(Endpoint.API.ASSEMBLY_STATUSES, null, null, response => {
            if (response.code === 200) {
                let assemblyStatuses = response.data
                this.fetchBadgeCount(undefined)
                assemblyStatuses.forEach((item, index) => {
                    this.fetchBadgeCount(item.id)
                })
                let assemblyStatusId = null
                assemblyStatuses.map((assemblyStatus)=>{
                    if (key == assemblyStatus.sortir) {
                        assemblyStatusId = assemblyStatus.id
                    }
                })
                this.setState({
                    assemblyStatusId:assemblyStatusId,
                    assemblyStatuses: assemblyStatuses
                }, () => {
                    this.fetchAll(this.state.ascending, this.state.sortir, this.state.inputSearch, true)
                })
            }
        }, true, true)
    }

    fetchModels = () =>{
        this.get(Endpoint.API.MODELS, null, null, response=>{
            if(response.code===200){
                this.setState({
                    models : response.data
                })
            }
        }, true, true)
    }

    fetchAll = (ascending, sortir, search, progressing, excelMode) =>{
        let {page, assemblyStatusId, startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt, model} = this.state
        if(!model){
            model = {}
        }
        if(startCreatedAt){
            startCreatedAt += ' 00:00:00';
        }
        if(endCreatedAt){
            endCreatedAt += ' 00:00:00';
        }
        if(startUpdatedAt){
            startUpdatedAt += ' 00:00:00';
        }
        if(endUpdatedAt){
            endUpdatedAt += ' 00:00:00';
        }
        let params = {
            assemblyStatusId:assemblyStatusId,
            ascending:ascending,
            sortir:sortir,
            search:search,
            page:page-1,
            startCreatedAt:startCreatedAt,
            endCreatedAt:endCreatedAt,
            startUpdatedAt:startUpdatedAt,
            endUpdatedAt:endUpdatedAt,
            modelId:model.id,
            excelMode:excelMode
        }
        if(excelMode){
            this.asyncDownloadGet(Endpoint.API.NATIVE_ASSEMBLIES, {params:params}, null,true);
            return
        }
        this.get(Endpoint.API.NATIVE_ASSEMBLIES, {params:params}, null, res =>{
            if(res.code === 200){
                this.setState({
                    assemblies : res.data,
                    totalPage: res.totalPage,
                    totalElement: res.totalElement,
                    ['size-' + assemblyStatusId ? assemblyStatusId : "all"]: res.totalElement,
                    pageElement: res.pageElement,
                })
            }
        }, progressing, true);
    }

    refreshAssemblies = (ascending, sortir, progressing) => (
        this.setState({
            ascending:ascending,
            sortir:sortir,
        }, () => {
            this.fetchAll(ascending, sortir, this.state.inputSearch, progressing)
        })
    )

    resetFilter(){
        this.setState({
            page :1,
            totalPage:0,
            totalElement:0,
            pageElement:0,
            startCreatedAt:null,
            endCreatedAt:null,
            startUpdatedAt:null,
            endUpdatedAt:null,
            assemblies:[],
            assemblyStatus:null,
            assemblyStatusId:null,
            model:{},
            inputSearch : "",
        }, () => {
            changeParam3(this.props, 'page', 1, 'tab', this.state.key, 'search', this.state.inputSearch)
        })
    }

    createInspection = async (assembly) => {
        let {model} = assembly
        let validationParams = {params:{modelId:model.id, reference:assembly.reference}};
        this.showProgress()
        let response = await this.asyncGet(Global.API.MODEL_VALID_TO_APPLY, validationParams, null, false, true)
        if(isFailed(response)){
            this.openFailedDialog(label.Failed, response.message)
            return
        }
        let params = {params:{assemblyId:assembly.id}}
        response = await this.asyncGet(Global.API.INSPECTION_CREATE, params, null, false, true)
        this.closeProgress()
        if(isSuccess(response)){
            let inspection = response.data;
            this.setState({
                createInspectionConfirmModal:false,
                createInspectionSuccessModal:true,
                inspection
            })
        }else if(isFailed(response)){
            this.errorToast(response.message)
        } else{
            this.errorToast(label.Failed)
        }
    }



    render() {
        let totalElement = this.state.totalElement
        let totalPage = this.state.totalPage
        let {models, model, modelModal, selectedAssembly, assemblyDetailModal, createInspectionConfirmModal, createInspectionSuccessModal, inspection} = this.state

        return (
            <Page
                title={label.Assemblies}
                breadcrumbs={[{ name: label.Assemblies, active: true }]}
                className="TablePage"
            >
                {super.render()}
                <AssemblyDetailModal
                    show={assemblyDetailModal}
                    assembly={selectedAssembly}
                    onContinueInspection={(assembly) => {
                        this.setState({createInspectionConfirmModal:true, assemblyDetailModal:false, selectedAssembly:assembly})
                    }}
                    onClose={() => {
                        this.setState({assemblyDetailModal:false, selectedAssembly:{}})
                    }}/>
                <CreateInspectionConfirmModal
                    show={createInspectionConfirmModal}
                    assembly={selectedAssembly}
                    onClickOk={async (assembly) => {
                        await this.createInspection(assembly)
                    }}
                    onClickCancel={() => {
                        this.setState({
                            scanModal:true,
                            createInspectionConfirmModal:false,
                            serialComponentModal:false,
                            inspection:undefined
                        })
                    }}
                />
                <CreateInspectionSuccessModal
                    show={createInspectionSuccessModal}
                    onClickOk={()=>{
                        this.props.history.push(InspectionFormCheckPage.BASE_ENDPOINT+'/'+inspection.reference)
                    }}
                    onClickCancel={()=>{
                        this.setState({
                                createInspectionSuccessModal:false, inspection:undefined}
                            , () => {
                                this.refreshDashboard()
                            })
                    }}
                    inspection={inspection}/>

                <ModelModal
                    show={modelModal}
                    model={model}
                    onClickOk={()=>{
                        this.setState({modelModal:false})
                    }}/>
                <Row key={1}>
                    <Col>
                        <Card>
                            <PrimaryCardHeader
                                content={(
                                    <React.Fragment>
                                        {
                                            (this.state.userFilterExpand)?(<FiArrowUpCircle/>):((<FiArrowDownCircle/>))
                                        }
                                        &nbsp;{label.AdvanceFilter} ({label.ClickToExpandFilterContent})
                                    </React.Fragment>
                                )}
                                style={{cursor:'pointer'}}
                                onClick={(e)=>{
                                    e.preventDefault()
                                    this.setState({
                                        userFilterExpand:!this.state.userFilterExpand
                                    })
                                }}
                            />
                            <Collapse isOpen={this.state.userFilterExpand}>
                                <CardHeader>
                                    <Row>
                                        <Col md={3}>
                                            <Label for="startCreatedAt">{label.CreatedStartDate}</Label>
                                            <DateInput
                                                id="startCreatedAt"
                                                value={this.state.startCreatedAt}
                                                maxdate={this.state.endCreatedAt}
                                                onChange={(e) =>{
                                                    let value = e.target.value
                                                    this.setState({
                                                        startCreatedAt : value?value:null
                                                    })
                                                }}
                                                placeholder={label.EnterStartDate}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Label for="endCreatedAt">{label.CreatedEndDate}</Label>
                                            <DateInput
                                                id="endCreatedAt"
                                                mindate={this.state.startCreatedAt}
                                                value={this.state.endCreatedAt}
                                                onChange={(e) =>{
                                                    let value = e.target.value
                                                    this.setState({
                                                        endCreatedAt :  value?value:null
                                                    })
                                                }}
                                                placeholder={label.EnterEndDate}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Label for="startUpdatedAt">{label.UpdatedStartDate}</Label>
                                            <DateInput
                                                id="startUpdatedAt"
                                                value={this.state.startUpdatedAt}
                                                maxdate={this.state.endUpdatedAt}
                                                onChange={(e) =>{
                                                    let value = e.target.value
                                                    this.setState({
                                                        startUpdatedAt : value?value:null
                                                    })
                                                }}
                                                placeholder={label.EnterStartDate}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Label for="endUpdatedAt">{label.UpdatedEndDate}</Label>
                                            <DateInput
                                                id="endUpdatedAt"
                                                mindate={this.state.startUpdatedAt}
                                                value={this.state.endUpdatedAt}
                                                onChange={(e) =>{
                                                    let value = e.target.value
                                                    this.setState({
                                                        endUpdatedAt :  value?value:null
                                                    })
                                                }}
                                                placeholder={label.EnterEndDate}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <ItemOption
                                                    title={label.SelectModel}
                                                    objects={models}
                                                    default={!isEmpty(model)?model.id:null}
                                                    callback={(model)=>{
                                                        this.setState({
                                                            model:model
                                                        })
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label>{label.Searching}</Label>
                                                <SearchInput
                                                    placeholder={label.SearchAssemblyByReferenceModelAndUserManufacturingSite}
                                                    value={this.state.inputSearch}
                                                    onChange={e=>{
                                                        this.setState({
                                                            inputSearch:e.target.value
                                                        }, () => {
                                                            if(this.state.inputSearch===''){
                                                                changeParam3(this.props, 'page', 1, 'tab', this.state.key, 'search', this.state.inputSearch)
                                                            }
                                                        })
                                                    }}
                                                    onEnter={e=>{
                                                        if(this.state.inputSearch!==''){
                                                            changeParam3(this.props, 'page', 1, 'tab', this.state.key, 'search', this.state.inputSearch)
                                                        }
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Row>
                                                <Col>
                                                    <Card>
                                                        <CardHeader>
                                                            {label.TotalRecord}
                                                        </CardHeader>
                                                        <CardBody>
                                                            <h4 style={{color:'green'}}><strong>{totalElement}</strong></h4>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                <Col>
                                                    <Card>
                                                        <CardHeader>
                                                            {label.TotalPage}
                                                        </CardHeader>
                                                        <CardBody>
                                                            <h4 style={{color:'blue'}}>{totalPage}</h4>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={6}>
                                            <Row>
                                                <Col md={6}>
                                                    <Button
                                                        block
                                                        className={"float-left btn-main"}
                                                        color={"none"}
                                                        onClick={event => {
                                                            navigatePage(this.props, 1)
                                                        }}>
                                                        <IoMdSettings/>&nbsp;{label.ApplyFilter}
                                                    </Button>
                                                </Col>
                                                <Col md={6}>
                                                    <Button
                                                        block
                                                        className={"float-left btn-white-normal"}
                                                        color={"none"}
                                                        onClick={event => {
                                                            this.resetFilter()
                                                        }}>
                                                        <MdRestore/>&nbsp;{label.ResetFilter}
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardHeader>
                            </Collapse>
                        </Card>
                    </Col>
                </Row>
                {this.renderAssembly()}
            </Page>
        )
    }

    fetchBadgeCount(assemblyStatusId) {
        let {ascending, sortir, search, page, startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt, model} = this.state
        if(!model){
            model = {}
        }
        if(startCreatedAt){
            startCreatedAt += ' 00:00:00';
        }
        if(endCreatedAt){
            endCreatedAt += ' 00:00:00';
        }
        if(startUpdatedAt){
            startUpdatedAt += ' 00:00:00';
        }
        if(endUpdatedAt){
            endUpdatedAt += ' 00:00:00';
        }

        let params = {
            assemblyStatusId: assemblyStatusId,
            ascending: ascending,
            sortir: sortir,
            search: search,
            page: page - 1,
            startCreatedAt: startCreatedAt,
            endCreatedAt: endCreatedAt,
            startUpdatedAt: startUpdatedAt,
            endUpdatedAt: endUpdatedAt,
            modelId: model.id,
            excelMode: false,
            badgeCountMode:true
        }
        this.get(Endpoint.API.NATIVE_ASSEMBLIES, {params: params}, null, (response) => {
            if (response && response.code == 200) {
                this.setState({
                    ['size-' + assemblyStatusId ? assemblyStatusId : "all"]: response.totalElement
                })
            }
        }, false, false);
    }


    badgeTabLabel(label, assemblyStatusId, color) {
        let size = this.state['size-' + assemblyStatusId ? assemblyStatusId : "all"];
        if (!size || size == 0) {
            return (<span>{label}</span>)
        }
        return (
            <>
                <span>{label}</span>
                &nbsp;&nbsp;
                <span
                    style={{
                        paddingTop: '2px',
                        paddingBottom: '2px',
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        background: color ? color : 'red',
                        color: 'white',
                        borderRadius: '20%',
                        minWidth: '24px',
                        display: 'inline-block',
                        textAlign: 'center'
                    }}>
                    {size}
                </span>
            </>)
    }

    renderAssembly = () =>{
        let {ascending, sortir} = this.state
        let orderOptions = delegateObjectsForSelection({name:label.Reference, field:'ay.reference'}, {name:label.Created, field:'ay.created'}, {name:label.Updated, field:'ay.updated'})
        let ascendingOptions = delegateObjectsForSelection( {name:label.Descending, field:false}, {name:label.Ascending, field:true})
        return (
            <Row key={2}>
                <Col>
                    <Card>
                        <CardHeader>
                            <strong>{label.Assemblies}</strong>
                            <br/><br/>
                            <Row>
                                <Col md={12}>
                                    <ButtonGroup className="d-flex w-100">
                                        <DropdownInput
                                            title={label.SortBy}
                                            options={orderOptions}
                                            onSelect={(item) => {
                                                this.refreshAssemblies(ascending, item.field, true)
                                            }}
                                            onReset={() => {
                                                this.refreshAssemblies(ascending, "ay.created", true)
                                            }}/>
                                        &nbsp;&nbsp;&nbsp;
                                        <DropdownInput
                                            options={ascendingOptions}
                                            onSelect={(item) => {
                                                this.refreshAssemblies(item.field, sortir, true)
                                            }}
                                            onReset={() => {
                                                this.refreshAssemblies(true, sortir, true)
                                            }}/>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Tabs
                                activeKey={this.state.key}
                                onSelect={key =>{
                                    changeParam2(this.props, 'page', 1, 'tab', key)
                                }
                                }>
                                <Tab eventKey={label.All}
                                     title={this.badgeTabLabel(label.All, undefined, ASSEMBLY_STATUS_COLOR['ALL'])}>
                                    {this.renderAssemblyTable()}
                                </Tab>
                                {
                                    this.state.assemblyStatuses.map((item, index)=>(
                                        <Tab key={index} eventKey={item.id}
                                             title={this.badgeTabLabel(label(item.name), item.id, ASSEMBLY_STATUS_COLOR[item.name])}>
                                            {this.renderAssemblyTable()}
                                        </Tab>
                                    ))
                                }
                            </Tabs>
                        </CardBody>
                        <SockJsClient
                            url={Global.BASE_URL}
                            topics={[Endpoint.API.LISTEN_UPDATE_ASSEMBLIES]}
                            getRetryInterval={()=>300000}
                            autoReconnect={false}
                            heartbeat={60000}
                            onMessage={(message) => {
                                this.successToast(message)
                                this.fetchAll(this.state.ascending, this.state.sortir, this.state.inputSearch, true)
                            }}
                            ref={ (client) => { this.clientRef = client }} />
                    </Card>
                </Col>
            </Row>
        )
    }

    renderAssemblyTable = () =>{
        return (
            <Card>
                <CardBody>
                    <Table responsive hover>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>{label.ReferenceCode}</th>
                            <th>{label.FWVersion}/{label.Controller}</th>
                            <th>{label.Model}</th>
                            <th>{label.Status}</th>
                            <th>{label.Performer}</th>
                            <th>{label.Created}</th>
                            <th>{label.Updated}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.assemblies.map((item, index)=>(
                                <tr key={item.id}>
                                    <th scope="row">{((this.state.page-1)* this.state.pageElement)+(++index)}</th>
                                    <td>
                                        <a className="fs-6"
                                            href='#'
                                            onClick={event => {
                                                event.preventDefault()
                                                this.setState({assemblyDetailModal:true, selectedAssembly:item})
                                            }}>
                                            {item.reference}
                                        </a>
                                    </td>
                                    <td>
                                        <span className="text-primary fw-400 text-italic fs-7">
                                            {isEmpty(item.fwVersion)?"-":item.fwVersion}
                                        </span>
                                        <br/>
                                        <span className="fw-normal fw-bolder fs-7">
                                            {isEmpty(item.controller)?"-":item.controller}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="fs-6">
                                            <strong>{item.model.modelCategory.name}</strong>
                                        </span>
                                        <br/>
                                        <a  className="fs-7"
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.setState({
                                                    model: item.model,
                                                    modelModal: true
                                                })
                                            }}>
                                            {item.model.systemType}
                                        </a>
                                        <br/>
                                        <span className="h5">{label.PN}:</span><span className="font-italic text-underline h5">{item.model.partNumber}</span>

                                    </td>
                                    <td>
                                        <StatusWidget status={item.assemblyStatus} statusColors={ASSEMBLY_STATUS_COLOR}/>
                                    </td>
                                    <td>
                                        <UserButton {...this.props} user={item.user}/>
                                    </td>
                                    <td>{parseDate(item.created, DD_MM_YYYY_HH_MM_SS)}</td>
                                    <td>{parseDate(item.updated, DD_MM_YYYY_HH_MM_SS)}</td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </Table>
                </CardBody>
                <Pagination {...this.props} currentPage={parseInt(this.state.page)} pageCount={this.state.totalPage} />
            </Card>
        )
    }
}
export default Object.assign(AssemblyPage, {ENDPOINT : "/assemblies"})